// This is a custom hook that debounces a function call
// It is used to prevent the function from being called too often
// It is useful for search inputs

import { useRef, useCallback } from 'react';

function useDebouncedCallback<T extends (...args: any[]) => Promise<void>>(
  callback: T,
  delay: number = 300
): (...args: Parameters<T>) => Promise<void> {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const debouncedFn = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(async () => {
        await callback(...args);
      }, delay);
    },
    [callback, delay]
  ) as T;

  return debouncedFn;
}

export default useDebouncedCallback;